export default __webpack_public_path__ + "media/images/gallery/dark-menu-09019d3510d37cb055003d3061e11faa.jpg";